import { Col, Row } from 'antd';
import { useCallback, useEffect, useState } from 'react';

import { Button, SelectForm } from 'components';
import { useTitle } from 'contexts/TitleProvider';
import { icons } from 'utils/constants/icons';
import TableAverageOrder from './TableAverageOrder';

const spanCol = 8;
const { PlusOutlined } = icons;

const initData = {
  branchId: '',
  branchName: '',
  averageOrder: 0,
  currency: '',
  createBy: '',
  createAt: '',
  updateBy: '',
  updateAt: '',
};

const exampleData = [
  {
    id: 0,
    branchId: '5001',
    branchName: 'Nhiêu Tâm',
    averageOrder: 20000000,
    currency: 'VND',
    createBy: 'Nguyễn Hoàng',
    createAt: '20/10/2024 09:30:000',
    updateBy: 'Nguyễn Hoàng',
    updateAt: '20/10/2024 09:30:000',
  },
  {
    id: 1,
    branchId: '5002',
    branchName: 'Nhiêu Bắc',
    averageOrder: 20000000,
    currency: 'VND',
    createBy: 'Nguyễn Hoàng',
    createAt: '20/10/2024 09:30:000',
    updateBy: 'Nguyễn Hoàng',
    updateAt: '20/10/2024 09:30:000',
  },
];

const AverageOrder = () => {
  const { setTitle, setBreadcrumb } = useTitle();

  const [data, setData] = useState<any[]>([]),
    [selectedIndex, setSelectedIndex] = useState<number>();

  useEffect(() => {
    setTitle('Trung bình đơn hàng');
    setBreadcrumb([{ title: 'Hệ thống' }, { title: 'Trung bình đơn hàng' }]);

    setData(exampleData);
  }, []);

  const handleCreate = useCallback(() => {
    if (selectedIndex !== undefined) return;

    setData((prev: any) => [{ ...initData }, ...prev]);
    setSelectedIndex(0);
  }, [data]);

  const handleCancel = useCallback(() => {
    const newData = data.filter(
      (item: any) => item.id !== null && item.id !== undefined,
    );

    setData(newData);
    setSelectedIndex(undefined);
  }, [data]);

  const handleRowChange = useCallback(
    (record: any, newValue: any) => {
      if (!record.id) {
        setData([
          ...data.filter((item: any) => item.id !== record.id),
          { ...record, ...newValue },
        ]);
      } else {
        const newData = data.filter(
          (item: any) =>
            item.id !== null && item.id !== undefined && item.id !== record.id,
        );

        setData([...newData, { ...record, ...newValue }]);
      }

      setSelectedIndex(undefined);
    },
    [data],
  );

  return (
    <>
      <Row gutter={[8, 16]} align="middle" justify="end">
        <Col span={spanCol}>
          <SelectForm disabled placeholder="Chọn chi nhánh" options={[]} />
        </Col>
        <Col>
          <Button
            fill
            disabled
            title="Tạo"
            iconBefore={<PlusOutlined />}
            handleOnclick={handleCreate}
          />
        </Col>
      </Row>
      <TableAverageOrder
        data={data}
        loading={false}
        selectedIndex={selectedIndex}
        setSelectedIndex={setSelectedIndex}
        onCancel={handleCancel}
        onRowChange={handleRowChange}
      />
    </>
  );
};

export default AverageOrder;
